import { lazy } from 'react'
import { ROUTE_PATHS } from 'constants/index'
import Home from 'games/Home'

const KenoGame = lazy(() => import('games/Keno/GameTheme/KenoGame/index'))
const DiceGame = lazy(() => import('games/Dice/GameTheme/DiceGame/index'))
const HiloGame = lazy(() => import('games/HiLo/GameTheme/HiLoGame/index'))
const CrashGame = lazy(() => import('games/CrashGames/GameTheme/FlyCrashGame/index'))
const CoinFlipGame = lazy(() => import('games/FlipCoin/GameTheme/FlipCoinGame/index'))
const PyramidPlinkoGame = lazy(() => import('games/Plinko/GameTheme/PyramidPlinkoGame/index'))
const GongaMineGame = lazy(() => import('games/Mines/GameTheme/GongaMineGame/index'))
const BBCrossGame = lazy(() => import('games/BbCrossGame/GameTheme/BbCross/index'))
const TowerGame = lazy(()=> import('games/TowerGame/index'))

const routesList = [
  {
    path: ROUTE_PATHS.home,
    component: Home,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.crashGame,
    component: CrashGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.kenoGame,
    component: KenoGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.diceGame,
    component: DiceGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.hiloGame,
    component: HiloGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.coinFlipGame,
    component: CoinFlipGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.pyramidPlinkoGame,
    component: PyramidPlinkoGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.gongaMineGame,
    component: GongaMineGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.bbCrossGame,
    component: BBCrossGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.towerGame,
    component: TowerGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  }

]

export default routesList
